var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-btn-bg"},[_c('p',{staticClass:"title"},[_vm._v("使用轻变聚合领先的智能变现工具，开启您的增收之旅")]),_c('div',{staticClass:"submit",on:{"click":_vm.handleClick}},[_vm._v("马上合作")])])
}
var staticRenderFns = []

export { render, staticRenderFns }